// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__3nCuP","loader-animation":"loader_loader-animation__2Jfhy"};